export default __webpack_public_path__ + "static/media/12.e72cc3f9.jpg";